<template>
    <div class="about">
        <section>
            <div class="background-panel"></div>
            <div class="content flex-h2">
                <div class="overlay">
                    <div class="image-wrapper">
                        <img src="/assets/img/fresse.png" class="inner-image" />
                    </div>
                </div>
                <div class="overlay">
                    <div class="overlay__content">
                        <prismic-rich-text :field="this.about.text" />
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import HeadlineWithLabel from '@/components/typography/HeadlineWithLabel';
    import ArticleRendererVue from '../components/ArticleRenderer.vue';

    export default {
        components: {
            HeadlineWithLabel,
            ArticleRendererVue
        },
        data() {
            return {
                about: null
            }
        },
        created() {
            this.getAbout()
        },
        methods: {
            getAbout() {
                this.$prismic.client.getSingle('about')
                    .then((document) => {
                        console.log(document)
                        this.about = document.data
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            }
        }
    }
</script>

<style lang="scss">
    @import '../assets/scss/base.scss';

    .about {

        h1,
        h2,
        p {
            color: $dark;
        }

        a {
            background: $dark-background !important;
            color: $white-100;
        }

        section {
            @include about-width () {
                background: $white-100;
            }

            position: relative;

            @include md() {
                padding-top: 0 !important;
            }
        }
    }

    .image-wrapper {
        position: relative;
        /* Make the wrapper relative */
        width: 93%;
        height: 40rem;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 16px;
        margin: 1rem 0;
        padding: 0 1rem;
        overflow: hidden;
        /* Ensures that the image does not overflow the border-radius */

        /* Pseudo element for blend mode */
        &::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: $dark;
            padding: 0 1rem;
            opacity: 0.4;
            /* Replace with your dark color */
            background-blend-mode: luminosity;
            /* Your blend mode */
            pointer-events: none;
            /* Allow clicks to pass through */
            z-index: 1;
            /* Above the image */
        }
    }

    .inner-image {
        position: absolute;
        /* Make the image absolute */
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        /* Cover without stretching */
        z-index: 0;
        /* Below the pseudo-element */
    }

    /* Your media query */
    @include md() {
        .image-wrapper {
            width: 100%;
            height: 20rem;
        }
    }



    .big-sized {
        font-size: 3.3rem;
        line-height: 1;
    }

    .background-panel {
        position: absolute;
        top: 4rem;
        right: 10%;
        width: 65%;
        height: calc(100% - 8rem);
        background: $light-background;
        z-index: 0;
        border-radius: 8px;

        @include about-width () {
            width: 100%;
            right: 0;
            left: 0;
        }
    }



    .overlay {
        z-index: 1;

        @include md () {
            width: 100% !important;
            margin: 0 !important;
            padding: 0 !important;
            right: 10%;
            left: 10%;
        }
    }
</style>